<form [formGroup]="numberPlatesForm">

  <table class="common-style">
    <tr>
      <th>
        <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.transport-creation-profiles.active"></sc-dictionary-label>
      </th>
      <th>
        <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.numberplate"></sc-dictionary-label>
      </th>
      <th></th>
    </tr>
    @for (numberPlate of numberPlates; track numberPlate) {
      <tr>
        <td class="centered-column">
          <div (click)="changeActive(numberPlate)">
            @if (!numberPlate.active) {
              <i class="fa-regular fa-square pointer"></i>
            }
            @if (numberPlate.active) {
              <i class="fa-regular fa-square-check pointer"></i>
            }
          </div>
        </td>
        <td>
          {{numberPlate.numberPlate}}
        </td>
        <td>
          <div (click)="this.delete(numberPlate)">
            <sc-icon iconClass="fa-trash pointer"></sc-icon>
          </div>
        </td>
      </tr>
    }
    @if (numberPlates == null || numberPlates.length === 0) {
      <tr>
        <td colspan="3" class="centered-column">
          <sc-dictionary-label dictionaryKey="tmc-yard.common.message.no-data"></sc-dictionary-label>
        </td>
      </tr>
    }

  </table>

  <sc-content-spacer vertical></sc-content-spacer>

  <sc-flex>
    <sc-string-field formControlName="newNumberPlate"
    labelDictionaryKey="tmc-yard.entity.transport.numberplate"></sc-string-field>
    <sc-content-spacer vertical></sc-content-spacer>
    <sc-add-button [disabled]="!addNewEnabled()" (click)="this.addNewNumberPlate()"> </sc-add-button>
  </sc-flex>
</form>
